import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { useEffect, useState } from "react"
import classes from "./styles.module.css"

/**
 * The rotating one-liner shown beneath the sign-in card on the default
 * Lexicanon login — short product truths that gently cross-fade (out, swap,
 * in) on a single line. Pure presentation; rotation is local animation state.
 * `prefers-reduced-motion` aware (no transition, lines still rotate quietly).
 */
const TAGLINES = [
  msg`Every decision, captured.`,
  msg`Action items, never lost.`,
  msg`Every conversation, searchable.`,
  msg`No bot in the room.`,
  msg`The room remembers.`,
  msg`Who said what, on the record.`,
  msg`Notes that write themselves.`,
  msg`Every meeting, made canon.`,
]
const HOLD_MS = 4400
const FADE_MS = 480

export function LoginTagline(): React.JSX.Element {
  const { i18n } = useLingui()
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    let swap: ReturnType<typeof setTimeout>
    const cycle = setInterval(() => {
      setVisible(false) // fade the current line out
      swap = setTimeout(() => {
        setIndex((i) => (i + 1) % TAGLINES.length) // swap text while invisible
        setVisible(true) // fade the new line in
      }, FADE_MS)
    }, HOLD_MS)
    return () => {
      clearInterval(cycle)
      clearTimeout(swap)
    }
  }, [])

  return <p className={`${classes.tagline}${visible ? "" : ` ${classes.hidden}`}`}>{i18n._(TAGLINES[index])}</p>
}
